module.exports = __webpack_public_path__ + "img/b1.0a79f5fc.jpg";